<template>
  <g class="eco2">
    <g
      v-for="(eco2Visualization, index) in eco2Visualizations"
      :key="index"
      :transform="`translate(${eco2Visualization.positionX} -${eco2Visualization.positionY})`"
    >
      <use
        x="-2"
        y="-2"
        width="4"
        height="4"
        :xlink:href="`#eco2-volume${level(eco2Visualization.eco2)}`"
      />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';

export default {
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    eco2Visualizations: (vm) => vm.spots.filter((spot) => vm.isOpenSpot(spot)).map((spot) => vm.buildEco2By(spot)),
    eco2VisualizationConfig:() => config.visualizationHeaders['eco2'],
    eco2MinValue: (vm) => vm.eco2VisualizationConfig.minValue,
    eco2MaxValue: (vm) => vm.eco2VisualizationConfig.maxValue,
    eco2ColorCount: (vm) => vm.eco2VisualizationConfig.colors.length,
    level: (vm) => (value) => vm.calculateEco2Level(value),
  },
  methods: {
    isOpenSpot(spot) {
      return spot.spotState && spot.type.indexOf('OpenSpot') >= 0;
    },
    calculateEco2Level(value) {
      if (this.eco2MaxValue <= this.eco2MinValue || !Number.isFinite(value)) return 1;

      const normalized = Math.max(0, Math.min(1, (value - this.eco2MinValue) / (this.eco2MaxValue - this.eco2MinValue)));
      const level = Math.round(normalized * (this.eco2ColorCount - 1)) + 1;
      return level;
    },
    buildEco2By(spot) {
      return {
        positionX: spot.positionX,
        positionY: spot.positionY,
        eco2: spot.spotState.eco2 || 1,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// eco2.vue?71ce3b66